export function getTestStatusDetails(test) {
  const now = new Date();
  const dueDate = test.nextDueDate ? new Date(test.nextDueDate) : null;
  const expiryDate = test.nextExpiryDate ? new Date(test.nextExpiryDate) : null;
  const overdueDate = test.overdue ? new Date(test.overdue) : null;

  let expiryAlertDays = 0;
  if (test.alertInfo && typeof test.alertInfo.expiryAlertDays !== "undefined" && test.alertInfo.expiryAlertDays !== null) {
    expiryAlertDays = parseInt(test.alertInfo.expiryAlertDays, 10);
  }

  const isExpiringSoon = expiryDate ? isDateWithinDays(now, expiryDate, expiryAlertDays) : false;

  const status = determineTestStatus(dueDate, expiryDate, overdueDate, isExpiringSoon);
  const { statusLine1, statusLine2 } = getStatusLines(dueDate, expiryDate, overdueDate, status);

  return { status, statusLine1, statusLine2 };
}

export function isDateWithinDays(fromDate, toDate, days) {
  const start = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
  const end = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
  const diffInMs = end - start;
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  return diffInDays >= 0 && diffInDays <= days;
}

export function determineTestStatus(dueDate, expiryDate, overdueDate, isExpiringSoon) {
  const now = new Date();
  if (overdueDate && overdueDate <= now) return "overdue";
  if (!dueDate || !expiryDate) return "upcoming";
  if (dueDate > now && expiryDate > now) return "upcoming";
  if (dueDate <= now && expiryDate > now) {
    return isExpiringSoon ? "expiring" : "due";
  }
  return "upcoming";
}

export function formatTimeDelta(toDate, absolute = false) {
  const now = new Date();
  const diffMs = toDate - now;
  const diff = absolute ? Math.abs(diffMs) : diffMs;
  const diffHours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diffHours / 24);
  const hours = Math.abs(diffHours % 24);
  return days !== 0 ? `${days}d ${hours}h` : `${hours}h`;
}

export function getStatusLines(dueDate, expiryDate, overdueDate, status) {
  let statusLine1 = "";
  let statusLine2 = "";

  if (status === "upcoming") {
    if (dueDate) {
      statusLine1 = `Upcoming in ${formatTimeDelta(dueDate)}`;
    }
    if (expiryDate) {
      statusLine2 = `Expiring in ${formatTimeDelta(expiryDate)}`;
    }
  } else if (status === "due" || status === "expiring") {
    if (expiryDate) {
      statusLine1 = `Expiring in ${formatTimeDelta(expiryDate)}`;
    }
  } else if (status === "overdue") {
    if (overdueDate) {
      statusLine1 = `Overdue by ${formatTimeDelta(overdueDate, true)}`;
    }
  }

  return { statusLine1, statusLine2 };
}



// WEBPACK FOOTER //
// ./src/components/PiScheduler/getTestStatusUtils.js